import { Theme } from '@mui/material';
import { button } from './button';
import { merge } from 'lodash';
import { textField } from './textfield';
import { typography } from './typography';
import { checkbox } from './checkbox';
import { autocomplete } from './autocomplete';
import { popover } from './popover';
import { paper } from './paper';

export function componentsOverrides(theme: Theme) {
  const components = merge(
    button(theme),
    textField(theme),
    typography(),
    checkbox(),
    autocomplete(),
    popover(theme),
    paper(theme)
  );
  return components;
}
